module.exports = __webpack_public_path__ + "00cf9a822ad430a0cbded94035b47b4b.pdf";